module.exports = __webpack_public_path__ + "static/Gotham-Book-9c9978d01033c81d8eae51948c433113.woff";